import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';

const borderColor = '#C12B2D';
const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		borderBottomColor: '#C12B2D',
		borderBottomWidth: 1,
		alignItems: 'center',
		height: 24,
		fontStyle: 'bold',
	},
	name: {
		width: '80%',
		textAlign: 'left',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		paddingLeft: 8,
		textTransform: 'capitalize',
	},
	description: {
		width: '30%',
		textAlign: 'left',
		borderRightColor: borderColor,
		borderRightWidth: 1,
		paddingLeft: 8,
	},
	// qty: {
	//   width: "20%",
	//   borderRightColor: borderColor,
	//   borderRightWidth: 1,
	//   textAlign: "right",
	//   paddingRight: 8,
	// },
	//   rate: {
	//     width: "15%",
	//     borderRightColor: borderColor,
	//     borderRightWidth: 1,
	//     textAlign: "right",
	//     paddingRight: 8,
	//   },
	rate: {
		width: '20%',
		textAlign: 'right',
		paddingRight: 8,
	},
});

const InvoiceTableRow = ({ items }) => {
	const { t } = useTranslation();
	console.log(items, 'items here');
	const rows = items.map((item) => (
		<View
			style={styles.row}
			key={item._id}>
			<Text style={styles.name}>{item.name}</Text>
			{/* <Text style={styles.description}>{item.quantity}</Text> */}
			{/* <Text style={styles.qty}>{item.quantity}</Text> */}
			<Text style={styles.rate}>{t('free')}</Text>
			{/* <Text style={styles.amount}>{(item.qty * item.rate).toFixed(2)}</Text> */}
		</View>
	));
	return <Fragment>{rows}</Fragment>;
};

export default InvoiceTableRow;
